import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, List, ListItem, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { deleteFile, UploadedJobFile, uploadFile } from "src/sites/file/droparea/expiringFiles";
import FileDropzone, { acceptableFileFormats, acceptableFileTypes, FilesItem } from "src/sites/file/droparea/FileDropzone";
import CustomTextarea from "src/sites/text/CustomTextarea";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import CommentOutlinedIcon from '@mui/icons-material/CommentOutlined';
import { Comment, ReferenceFile } from "src/services/api/document"
import { dateWithTime } from "src/utils/dateHelper";

interface InstructionsDialogProps {
    open: boolean
    initialReferenceFiles: ReferenceFile[]
    initialComments: Comment[]
    onSubmit: (files: UploadedJobFile[], comment?: string) => void
    onDismiss: () => void
}

export const InstructionsDialog = ({ open, initialReferenceFiles, initialComments, onSubmit, onDismiss }: InstructionsDialogProps) => {
    const [referenceFiles, setReferenceFiles] = useState<FilesItem[]>([])
    const [comment, setComment] = useState<string>()

    const uploadReferenceFile = (file: File) => {
        return uploadFile(file)
    }

    const onSubmitClick = () => {
        onSubmit(referenceFiles.map(f => f.uploadedFile).filter(f => f) as UploadedJobFile[], comment)
        setReferenceFiles([])
        setComment(undefined)
    }

    return <Dialog open={open} PaperProps={{style: {maxWidth: "none", maxHeight: "90%", padding: '30px'}}} onClose={onDismiss}>
        <DialogContent sx={{ width: '1000px', maxHeight: '90%' }}>
            <DialogTitle variant="h3">{"Add instructions or reference files"}</DialogTitle>
            <Stack spacing={2}>
                <Box sx={{ height: '210px' }}>
                    <FileDropzone
                        id={'reference-files-dropzone'}
                        files={referenceFiles}
                        setFiles={setReferenceFiles}
                        fileFormats={acceptableFileFormats}
                        fileTypes={[...acceptableFileTypes]}
                        placing='Portal reference files'                        
                        uploadFiles={uploadReferenceFile}
                        deleteFile={deleteFile}
                    />
                </Box>
                <Box>
                    <CustomTextarea
                        value={comment}
                        onChange={e => setComment(e.target.value)}
                        rows={7}
                        sx={{ borderRadius: '25px', p:3 }}
                        placeholder="Comment here"
                    />
                </Box>
                {!!initialReferenceFiles.length && <Box>
                    <Stack direction={'row'} alignItems={'center'} spacing={1}>
                        <AttachFileIcon color={'primary'}/>
                        <Typography variant="h6">{"Reference Files"}</Typography>
                    </Stack>
                    <List sx={{ pl: 2 }}>
                        {initialReferenceFiles.map(f => <ListItem>{f.name}</ListItem>)}
                    </List>
                    <Divider />
                </Box>}
                {!!initialComments.length && <Box>
                    <Stack direction={'row'} alignItems={'center'} spacing={1}>
                        <CommentOutlinedIcon color={'primary'}/>
                        <Typography variant="h6">{"Comments"}</Typography>
                    </Stack>
                    {initialComments.map(c => <>
                        <Stack sx={{pt: 1, pb: 3}}>
                            <Typography variant="body2" sx={{ pl: 4 }}>{dateWithTime(c.date)}</Typography>
                            <Typography variant="body1" sx={{ whiteSpace: "pre-wrap", pl: 4 }}>{c.content}</Typography>
                        </Stack>
                    </>)}
                    <Divider />
                </Box>}
            </Stack>
            <DialogActions sx={{pt: 3}}>
                <Button
                    variant="contained"
                    onClick={onSubmitClick}
                    disabled={!comment && !referenceFiles.length} > {"Submit"} </Button>
                <Button variant="outlined" onClick={onDismiss}>{"Dismiss"}</Button>
            </DialogActions>
        </DialogContent>
    </Dialog>
}